import { Outlet } from "react-router-dom";
import { Loader } from "@/common/components/atoms/loader/loader";
import { useSelector } from "react-redux";
import { IAppContextModel } from "@/store/app/types";
import styles from "./page.module.scss";

export const Page = (props: any) => {
  const appContext: IAppContextModel = useSelector(
    (state: any) => state.appContext
  );

  return (
    <div className={styles.page}>
      {props.header && (
        <header data-cy="header" className={styles.pageHeader}>
          {props.header}
        </header>
      )}
      {props.hasChild ? (
        <div
          className={`${styles.pageContent} ${
            props.hasShadow ? styles.pageContentShadow : ""
          }`}
        >
          {props.children}
          <Loader showLoader={appContext.showLoader} />
        </div>
      ) : (
        <div
          className={`${styles.pageBody} ${
            props.noPageBodyScroll ? styles.pageBodyNoScroll : ""
          }`}
        >
          <Outlet />
          <Loader showLoader={appContext.showLoader} />
        </div>
      )}
    </div>
  );
};
